import React from 'react';
import logo from '../../images/logo.png';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <img src={logo} alt=""/>
             <h1> Best ODI Squad </h1>
        
        
         <nav>
             <a href="/home">Home</a>
             <a href="/matches">Matches</a>
             <a href="/more">More</a>
         </nav>
            
        </div>
    );
};

export default Header;